const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000/api';

export type SystemParameters = {
  id: string;
  company_id: string | null;
  min_sleep_duration: number;
  sleep_data_interval: number;
  heart_rate_interval: number;
  blood_oxygen_interval: number;
  pressure_interval: number;
  location_interval: number;
  sleep_quality_formula: {
    deep_weight: number;
    light_weight: number;
    rem_weight: number;
  };
  created_at: string;
  updated_at: string;
};

export const systemParametersService = {
  async getParameters(companyId?: string): Promise<SystemParameters> {
    const token = localStorage.getItem('authToken');
    const url = companyId 
      ? `${API_BASE_URL}/system-parameters?companyId=${companyId}`
      : `${API_BASE_URL}/system-parameters`;

    const response = await fetch(url, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const errorMessage = errorData.message || errorData.error || 'Failed to fetch system parameters';
      throw new Error(errorMessage);
    }

    const result = await response.json();
    return result.data;
  },

  async updateParameters(data: Partial<SystemParameters>): Promise<SystemParameters> {
    const token = localStorage.getItem('authToken');
    
    const response = await fetch(`${API_BASE_URL}/system-parameters`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const errorMessage = errorData.message || errorData.error || 'Failed to update system parameters';
      throw new Error(errorMessage);
    }

    const result = await response.json();
    return result.data;
  }
};
